module.exports = __webpack_public_path__ + "static/media/googleplay_ic.28cb6283.png";